import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isA11yClick } from '../../../util/accessabilityUtils';
import { helpModalControl } from '../../modals/HelpModalControl';

class LinkedModalUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
  }

  handleHelpClick(e) {
    e.preventDefault();
    const { toggleHelpModal, helpModalId } = this.props;
    if (isA11yClick(e)) {
      toggleHelpModal(helpModalId);
    }
  }

  render() {
    const {
      children,
    } = this.props;
    return (
      <div
        className="haz-pointer-cursor"
        tabIndex={0}
        onClick={this.handleHelpClick}
        onKeyDown={this.handleHelpClick}
        role="button"
        aria-label="help"
        aria-hidden="false"
      >
        <b>
          {children}
        </b>
      </div>
    );
  }
}


LinkedModalUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string.isRequired,
};

export const LinkedModal = helpModalControl(LinkedModalUnwrapped);
